"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHubspot = void 0;
function useHubspot() {
    var hubSpotHandler = {
        formId: '',
        onFormReady: undefined,
        onFormSubmitted: undefined,
    };
    function initHBSPTForm(hubSpotFormCreation) {
        var formId = hubSpotFormCreation.formId, targetId = hubSpotFormCreation.targetId, createdCallBack = hubSpotFormCreation.createdCallBack, portalId = hubSpotFormCreation.portalId;
        window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            target: "#".concat(targetId),
        });
        if (createdCallBack && typeof createdCallBack === 'function') {
            if (createdCallBack)
                createdCallBack();
        }
    }
    function createHubspotForm(hubSpotFormCreation) {
        var hbsptScript = document.getElementById('hbspt-script');
        if (!hbsptScript) {
            // Reset subscribers
            ;
            window.$hsScriptOnLoad = [];
            // Inject hbsptScript in DOM
            var script = document.createElement('script');
            script.defer = true;
            script.id = 'hbspt-script';
            script.src = 'https://js.hsforms.net/forms/v2.js';
            script.onload = function () {
                ;
                window.$hsScriptOnLoad.forEach(function (callback) { return callback(); });
            };
            document.body.appendChild(script);
        }
        if (!window.hbspt) {
            ;
            window.$hsScriptOnLoad.push(function () {
                initHBSPTForm(hubSpotFormCreation);
            });
        }
        else {
            initHBSPTForm(hubSpotFormCreation);
        }
    }
    function handleHubspotEvent(event) {
        if (event.data.id !== hubSpotHandler.formId) {
            return;
        }
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
            if (hubSpotHandler.onFormReady)
                hubSpotHandler.onFormReady();
            return;
        }
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            if (hubSpotHandler.onFormSubmitted)
                hubSpotHandler.onFormSubmitted();
        }
    }
    function initHbFormListener(hubSpotFormHandler) {
        var formId = hubSpotFormHandler.formId, onFormReady = hubSpotFormHandler.onFormReady, onFormSubmitted = hubSpotFormHandler.onFormSubmitted;
        if (hubSpotHandler.formId) {
            return;
        }
        hubSpotHandler.formId = formId;
        hubSpotHandler.onFormReady = onFormReady;
        hubSpotHandler.onFormSubmitted = onFormSubmitted;
        if (!window.hbListeners) {
            window.hbListeners = {};
        }
        // Avoid duplicated listener
        if (!window.hbListeners[formId]) {
            window.addEventListener('message', handleHubspotEvent);
            window.hbListeners[formId] = true;
        }
    }
    function removeHbFormListener() {
        var _a;
        if ((_a = window.hbListeners) === null || _a === void 0 ? void 0 : _a[hubSpotHandler.formId]) {
            window.hbListeners[hubSpotHandler.formId] = false;
        }
        hubSpotHandler.formId = '';
        window.removeEventListener('message', handleHubspotEvent);
    }
    // Method to force hubspot react component to clean up before destroy
    function unmountReactComponent(formId) {
        var _a;
        var windowReactForms = (_a = window === null || window === void 0 ? void 0 : window.HSFR) === null || _a === void 0 ? void 0 : _a.FORM_COMPONENTS;
        if (windowReactForms === null || windowReactForms === void 0 ? void 0 : windowReactForms.length) {
            var formsIndex = windowReactForms.findIndex(function (node) { return node.props.formId === formId; });
            if (formsIndex !== -1 && windowReactForms[formsIndex]) {
                windowReactForms[formsIndex].componentWillUnmount();
                windowReactForms.splice(formsIndex, 1);
            }
        }
    }
    return {
        createHubspotForm: createHubspotForm,
        initHbFormListener: initHbFormListener,
        removeHbFormListener: removeHbFormListener,
        unmountReactComponent: unmountReactComponent,
        hubSpotHandler: hubSpotHandler,
    };
}
exports.useHubspot = useHubspot;
//# sourceMappingURL=useHubspot.js.map